// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"U5-z"};